import { Data_getInstance1e0nvut8dxxwv as Data_getInstance } from './adapter/SavePinMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SavePinMutationSelections_getInstance1ybpjedna4yba as SavePinMutationSelections_getInstance } from './selections/SavePinMutationSelections.mjs';
import { SavePinMutation_VariablesAdapter_instance3iph10kl6nehk as SavePinMutation_VariablesAdapter_instance } from './adapter/SavePinMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(savePin) {
        this.h6h_1 = savePin;
      }
      toString() {
        return 'Data(savePin=' + this.h6h_1 + ')';
      }
      hashCode() {
        return this.h6h_1 == null ? 0 : getBooleanHashCode(this.h6h_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.h6h_1 == other.h6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.i6h_1 = obj(Data_getInstance());
        this.j6h_1 = (new (Builder())('data', Companion_getInstance().x6d_1)).t43(SavePinMutationSelections_getInstance().m6h_1).j37();
        this.k6h_1 = '16ed341f62125adac6d4641ec718698f5efb684fe32af3e92d15f74176c9023c';
        this.l6h_1 = 'savePin';
      }
      a6e() {
        return 'mutation savePin($input: SavePinInput!) { savePin(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SavePinMutationClass;
function SavePinMutation() {
  if (SavePinMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.n6h_1 = input;
      }
      c6e() {
        return '16ed341f62125adac6d4641ec718698f5efb684fe32af3e92d15f74176c9023c';
      }
      operationId() {
        return this.c6e();
      }
      m47() {
        return Companion_getInstance_0().a6e();
      }
      d6e() {
        return 'savePin';
      }
      operationName() {
        return this.d6e();
      }
      q46(writer, customScalarAdapters, withDefaultValues) {
        SavePinMutation_VariablesAdapter_instance.o6h(writer, this, customScalarAdapters, withDefaultValues);
      }
      p46() {
        return Companion_getInstance_0().i6h_1;
      }
      toString() {
        return 'SavePinMutation(input=' + this.n6h_1.toString() + ')';
      }
      hashCode() {
        return this.n6h_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinMutation()))
          return false;
        if (!this.n6h_1.equals(other.n6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinMutation', VOID, VOID, [Mutation()]);
    SavePinMutationClass = $;
  }
  return SavePinMutationClass;
}
//region block: exports
export {
  Data as Datagefyj3dojvb5,
  SavePinMutation as SavePinMutation3865jhueq4vmv,
};
//endregion

//# sourceMappingURL=SavePinMutation.mjs.map
